
<div class="gt-routes-list-containerss">

    <dx-data-grid id="gridContainer" #exportConfigGrid [dataSource]="exportConfig"
        class="gt-data-grid-style export-grid" (onSaved)="onSaved($event)" [showRowLines]="true" [showBorders]="true"
        [editing]="{ mode: 'form', texts: { saveRowChanges: confirmText, cancelRowChanges: cancelText }}"
        [allowColumnResizing]="true" [columnResizingMode]="'widget'" [columnAutoWidth]="false" [showBorders]="true"
        [scrolling]="{ mode: 'standard', useNative: true }" [width]="'100%'" class="gt-data-grid-style"
        [rowAlternationEnabled]="true" [hoverStateEnabled]="true">
        <dxo-scrolling mode="virtual"></dxo-scrolling>
        <dxo-editing mode="form"></dxo-editing>
        <dxo-search-panel i18n-placeholder="@@search..." placeholder="Search..." [visible]="true" [highlightCaseSensitive]="false" class="gt-search-panel"
            width="17vw"></dxo-search-panel>
        <dxo-toolbar>
            <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
            <dxi-item width="50%">
                <div class="gt-flex-dir-row">
                    <app-gpd-button
                      icon="add"
                      i18n-text="@@add"
                      text="Add"
                      (onClick)="addNewGroup($event)"
                    ></app-gpd-button>
                </div>
            </dxi-item>
        </dxo-toolbar>

        <dxi-column dataField="exportPackageTitle" i18n-caption="@@exportPackageTitle"
            caption="Export Package Title"></dxi-column>
        <dxi-column dataField="taskIds" i18n-caption="@@tasks" caption="Tasks" cellTemplate="cellTemplate"
            editCellTemplate="editCellTemplate">

            <div *dxTemplate="let item of 'cellTemplate'">
                <dx-tag-box class="readonly-task-tagbox" [dataSource]="exportConfigTasks" [readOnly]="true" [contentEditable]="false"
                    displayExpr="taskTitle" valueExpr="taskId" [showSelectionControls]="true"
                    [value]="item.data.taskIds">
                </dx-tag-box>
            </div>

            <div *dxTemplate="let item of 'editCellTemplate'">

                <dx-drop-down-box [dataSource]="exportConfigTasks" [value]="item.value" displayExpr="taskTitle"
                    valueExpr="taskId" (onValueChanged)="onDropDownBoxValueChanged($event.value)">

                    <div *dxTemplate="let data2 of 'content'">
                        <dx-tree-view #treeView [dataSource]="exportConfigTasks" dataStructure="plain" keyExpr="taskId"
                            parentIdExpr="parentTaskId" displayExpr="taskTitle" searchExpr="taskTitle"
                            searchMode="contains" [searchEnabled]="true" selectionMode="multiple"
                            (onContentReady)="onTreeViewReady($event, item.value)"
                            (onItemSelectionChanged)="onTreeViewSelectionChanged($event, item)"
                            showCheckBoxesMode="true">
                        </dx-tree-view>
                    </div>

                </dx-drop-down-box>
            </div>
        </dxi-column>

        <dxi-column dataField="sectionKeys" i18n-caption="@@exportSections" caption="Data & documents"
            cellTemplate="sectionsCellTemplate" editCellTemplate="sectionsEditCellTemplate">

            <div *dxTemplate="let item of 'sectionsCellTemplate'">{{ getSectionSummary(item.data) }}</div>

            <div *dxTemplate="let item of 'sectionsEditCellTemplate'">
                <dx-drop-down-box [dataSource]="exportConfigSectionItems" [value]="item.value"
                    displayExpr="text" valueExpr="key">
                    <div *dxTemplate="let data2 of 'content'">
                        <dx-tree-view [dataSource]="exportConfigSectionItems" dataStructure="plain"
                            keyExpr="key" parentIdExpr="parentKey" displayExpr="text" searchExpr="text"
                            searchMode="contains" [searchEnabled]="true" selectionMode="multiple"
                            showCheckBoxesMode="true" itemTemplate="sectionItem"
                            (onContentReady)="onSectionTreeReady($event, item.value)"
                            (onItemSelectionChanged)="onSectionSelectionChanged($event, item)">
                            <div *dxTemplate="let node of 'sectionItem'">{{ node.isDocument ? '📄 ' : '' }}{{ node.text }}</div>
                        </dx-tree-view>
                    </div>
                </dx-drop-down-box>
                <div class="stale-warning" *ngIf="getStaleText(item.data) as stale">{{ stale }}</div>
            </div>
        </dxi-column>

        <dxi-column dataField="" allowEditing="false" cellTemplate="buttonCellTemplate" [width]="68"
            [formItem]="{visible: false}">
            <div *dxTemplate="let item of 'buttonCellTemplate'">
                <div class="gpd-table-actions">
                        <app-svg-icon icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" (click)="editRow(item.data.id)"></app-svg-icon>
                        <app-svg-icon icon="delete" color="var(--color-red-500)" [size]="20" [strokeWidth]="1.5" i18n-title="@@delete" title="Delete" (click)="initDelete(item.data)"></app-svg-icon>
                    </div>
            </div>
        </dxi-column>
    </dx-data-grid>
</div>
<dx-toast [(visible)]="toastVisible" i18n-message="@@successfullySaved" message="Successfully saved"></dx-toast>
<app-delete-popup [visible]="deletePopupVisible" (onAbort)="deletePopupVisible = false;"
    (onConfirm)="deleteExportGroup($event)" [message]="deleteMessage"></app-delete-popup>